import { SavedHazardAssessment } from "../../../models/ReferenceData/HazardAssessment";
import { SAVE_HAZARD_ASSESSMENT, ADD_HAZARD_QUESTION_RESPONSE, REMOVE_HAZARD_QUESTION_RESPONSE, SAVE_GET_HAZARD_API_RESPONSE, SAVE_HHSRS_ASSESSMENT_COMPLETED, SAVE_POST_HAZARD_ASSESSMENT_RESPONSE, SAVE_PRE_ASSESSMENT_QUESTIONS_RESPONSE, SAVE_PRE_ASSESSMENT_RETURN_QUESTION, SAVE_STANDARD_REPAIR_PRIORITY, UPDATE_HAZARD_QUESTION_RESPONSE, SAVE_HAZARD_DETAILS, SAVE_ACTIVE_HAZARD_CASE, SAVE_ACTIVE_POP_HAZARD_CASE_FLAG, HAS_ACTIVE_HAZARD_CASE } from "../actionTypes";

export const saveHazardPostAssessmentResponse = (payload: any) => ({
  type: SAVE_POST_HAZARD_ASSESSMENT_RESPONSE,
  payload,
});

export const saveHHSRSAssessmentCompleted = (payload: boolean) => ({
  type: SAVE_HHSRS_ASSESSMENT_COMPLETED,
  payload,
});

export const resetHazardAssessmentData = (payload?: any) => ({
  type: REMOVE_HAZARD_QUESTION_RESPONSE,
  payload
});

export const updateHazardAssessmentAnswer = (payload: any) => ({
  type: UPDATE_HAZARD_QUESTION_RESPONSE,
  payload
});

export const addHazardAssessmentAnswer = (payload: any) => ({
  type: ADD_HAZARD_QUESTION_RESPONSE,
  payload
})

export const saveHazardGetQuestionsData = (payload: any) => ({
  type: SAVE_GET_HAZARD_API_RESPONSE,
  payload
})

export const savePreAssessmentReturnQuestion = (payload: any) => ({
  type: SAVE_PRE_ASSESSMENT_RETURN_QUESTION,
  payload
});

export const savePreAssessmentQuestionsData = (payload: any) => ({
  type: SAVE_PRE_ASSESSMENT_QUESTIONS_RESPONSE,
  payload
});

export const saveStandardRepairPriority = (payload: any) => ({
  type: SAVE_STANDARD_REPAIR_PRIORITY,
  payload,
});

export const saveHazardAssessment = (payload: SavedHazardAssessment) => ({ type: SAVE_HAZARD_ASSESSMENT, payload });

export const saveHazardDetails = (payload: any) => ({
  type: SAVE_HAZARD_DETAILS,
  payload,
});

export const saveActiveHazardCaseDetails = (payload: any) => ({
  type: SAVE_ACTIVE_HAZARD_CASE,
  payload,
});

export const saveActivePopHazardCaseFlag = (payload: boolean) => ({
  type: SAVE_ACTIVE_POP_HAZARD_CASE_FLAG,
  payload,
});
export const SavehasActiveHazardCase = (payload: any) => ({
  type: HAS_ACTIVE_HAZARD_CASE,
  payload,
});